import React, { useState } from 'react';
import { Tabs } from '@landing/ui';
import SectionContent from './SectionContent';

import * as styles from './Section.module.scss';

export default function Section({ tabsName, tabsContent, ...props }) {
  const initialTab = tabsContent ? tabsContent[0]?.id : null;

  const [opacity, setOpacity] = useState({
    '--opacity': 1,
  });
  const [active, setActive] = useState(initialTab);

  return tabsContent ? (
    <>
      {tabsName && (
        <Tabs filters={tabsName} active={active} setActive={setActive} setStyles={setOpacity} />
      )}
      {tabsContent.map(tab => (
        <div key={tab.id} style={opacity} className={tab.id !== active && styles.hidden}>
          <SectionContent {...tab} />
        </div>
      ))}
    </>
  ) : (
    <SectionContent {...props} />
  );
}
